import AssessmentIcon from '@mui/icons-material/Assessment';
import { Box, Button, CircularProgress, Paper, TextField } from '@mui/material';
import type { AutocompleteRenderInputParams } from '@mui/material/Autocomplete';
import Autocomplete from '@mui/material/Autocomplete';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { toast } from 'material-react-toastify';
import { ExperimentDescription } from '../../interfaces/Experiments';
import { getAllExperiments } from '../../services/experiments';
import { experimentsUIUrl } from '../../variables/Pages';

export default function ExperimentUI() {
  const navigate = useNavigate();
  const [allExperiments, setAllExperiments] = useState<ExperimentDescription[]>(
    [],
  );
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState<string>('');

  const filteredExperiments = allExperiments.filter((experiment) =>
    experiment.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  useEffect(() => {
    const fetchExperiments = async () => {
      try {
        const result = await getAllExperiments();
        setAllExperiments(result.experiments);
      } catch (error) {
        toast.error(`Error fetching experiments: ${error}`);
      } finally {
        setLoading(false);
      }
    };

    fetchExperiments();
  }, []);

  const columns: GridColDef[] = [
    { field: 'name', headerName: 'Name', minWidth: 250 },
    { field: 'enabled', headerName: 'Enabled', width: 120 },
    { field: 'description', headerName: 'Description', flex: 1 },
  ];

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Paper sx={{ padding: 3, margin: 2, maxWidth: '1200px', width: '100%' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '16px',
          }}
        >
          <h2>All Experiments</h2>
          <Button
            color='primary'
            onClick={() => navigate(`${experimentsUIUrl}/analysis`)}
            startIcon={<AssessmentIcon />}
            variant='contained'
          >
            Experiment Analysis
          </Button>
        </Box>
        <Autocomplete
          freeSolo
          onChange={(_event: any, value: any, reason: any) => {
            if (reason === 'selectOption') {
              navigate(`${experimentsUIUrl}/${value}`);
            }
          }}
          onInputChange={(_event: any, newInputValue: any) => {
            setSearchTerm(newInputValue);
          }}
          options={allExperiments.map((experiment) => experiment.name)}
          renderInput={(params: AutocompleteRenderInputParams) => (
            <TextField
              sx={{ margin: '0px 0px 5px 5px' }}
              {...params}
              fullWidth
              label='Search Experiments'
              onChange={(e) => setSearchTerm(e.target.value)}
              variant='filled'
            />
          )}
          sx={{ width: '80%', margin: '10px auto 10px ajut' }}
        />
        <DataGrid
          hideFooter
          columns={columns}
          getRowId={(row) => row.name}
          loading={loading}
          onRowClick={(params) =>
            navigate(`${experimentsUIUrl}/${params.row.name}`)
          }
          rows={filteredExperiments}
        />
        {loading && <CircularProgress />}
      </Paper>
    </Box>
  );
}
